 // Prérequis pour la mise en place d'Accordeon (balise H2 suivie d'un conteneur "Citations" [balise "blockquote"])
 jQuery(document).ready(function() {
     var i = 1;
     jQuery('.rte h2').each(function() {
         if ($(this).next().is('blockquote')) {
             jQuery(this).addClass('accordion-drag clearfix innerAccordeon' + i);
             i++;
         }
     });
     if (i === 1) return;
     i = 1;
     jQuery('.rte blockquote').each(function() {
         jQuery(this).addClass('accordion-content clear innerAccordeon' + i);
         jQuery(".innerAccordeon" + i).wrapAll("<div class='accordion-item clear' />");
         i++;
     });
     var allPanels = $('.accordion-content').hide();
     jQuery('.accordion-drag').on('click', function() {
         if (!$(this).parents('.accordion-item').hasClass('open')) {
             allPanels.slideUp();
             jQuery('.accordion-item.open').removeClass('open');
             jQuery(this).next().slideDown();
             jQuery(this).parents('.accordion-item').addClass('open');

         } else {
             jQuery('.accordion-item.open').removeClass('open');
             jQuery(this).next().slideUp();
             jQuery(this).parents('.accordion-item').removeClass('open');
         }
         return false;
     });
 });